var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"custom-logo",class:{ larger: _vm.larger, smaller: _vm.smaller },attrs:{"src":_vm.source,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }